import React from "react";
import { ListGroup, Badge, Row, Col } from "react-bootstrap";
import { FaAngleRight, FaCheck, FaRegCircle } from "react-icons/fa";
import { Link } from "react-router-dom";
import { toTitleCase } from "lib/utils/util";
import { PAGE_ROUTES } from "lib/constants/page-routes";
import SimpleCard from "../common/simple-card";
import { getTimeInAMPM } from "lib/utils/date-utils";
import RawHTML from "../common/raw-html";

const StatusIcon = ({ status }: { status: string }) => {
  switch (status) {
    case "completed":
      return <FaCheck className="text-success me-2" />;
    case "scheduled":
      return <FaAngleRight className="text-warning me-2" />;
    default:
      return <FaRegCircle className="text-secondary me-2" />;
  }
};

interface AppointmentsListProps {
  appointments: Appointment[];
  title: string;
  isLoading?: boolean
  error?: string
}

const AppointmentsList: React.FC<AppointmentsListProps> = ({
  appointments,
  title,
  isLoading,
  error
}) => {
  if (appointments.length === 0) {
    return (
      <SimpleCard title="Appointments" isLoading={isLoading} error={error}>
        <p>No appointments found</p>
      </SimpleCard>
    );
  }

  return (
    <Row>
      <Col xs={12}>
        <SimpleCard
          title={title}
          isLoading={isLoading}
          error={error}
          action={
            <Link
              to={PAGE_ROUTES.PRACTITIONER.AppointmentList}
              className="text-primary"
            >
              Show all
            </Link>
          }
        >
          <ListGroup variant="flush">
            {(appointments ?? []).map((appointment, index) => {
              return (
                <ListGroup.Item
                  key={index}
                  className="d-flex align-items-center justify-content-between"
                >
                  <div>
                    <StatusIcon status={appointment.status} />
                    <RawHTML html={`Appointment with <u>${appointment?.patientName}</u> at <u>${getTimeInAMPM(new Date(appointment.date))}</u>`} />
                  </div>
                  <Badge
                    className={`${appointment.status === "completed" ? "bg-success" : ""
                      } ${appointment.status === "scheduled" ? "bg-warning" : ""
                      }`}
                  >
                    {toTitleCase(appointment.status)}
                  </Badge>
                </ListGroup.Item>
              );
            })}
          </ListGroup>
        </SimpleCard>
      </Col>
    </Row>
  );
};

export default AppointmentsList;
